import { ManualActivity } from "../objects/manualActivity";
import { ManualActivityVariant } from "../objects/manualActivityVariant";


export const transformVariantFromBackend = (variant: ManualActivityVariant): ManualActivityVariant => ({
    ...variant,
    schedules: variant.schedules.map(schedule => ({ 
        ...schedule, 
        periods: 
        schedule.periods?.map(period => 
            ({ 
                ...period, 
                start_date: period.start_date? new Date(period.start_date): null,
                end_date: period.end_date? new Date(period.end_date): null 
            })) || [] 
        })),
        localization: variant.localization?.map(loc => ({
            ...loc,
            title: loc.title || "",
            short_description: loc.short_description || null,
            long_description: loc.long_description || null,
            locale: loc.locale,
            good_to_know: loc.good_to_know || '',
            voucher_text: loc.voucher_text || '',
            guide_lang: loc.guide_lang || [],
            not_recommended: loc.not_recommended || [],
            included: loc.included || [],
            not_included: loc.not_included || [],
            prohibited_items: loc.prohibited_items || [],
            information_required_at_booking: loc.information_required_at_booking || [],
            open_field_meeting_point: loc.open_field_meeting_point || null,
            open_field_return_point: loc.open_field_return_point || null
        })) || []
})

export const transformActivityFromBackend = (activity: ManualActivity): ManualActivity => ({
    ...activity,
    variants: activity.variants?.map(variant => transformVariantFromBackend(variant)) || []
});
